import React from 'react'
import PropTypes from 'prop-types'
import Avatar from '../../../atoms/Avatar'

const OwnerTaskItem = ({
  owner,
  layout,
  bordered
}) => {
  const initials = [owner.firstName, owner.lastName]
    .filter(Boolean)
    .map(s => s.charAt(0).toUpperCase())
    .join('')

  if (layout === 'row') {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '0.75rem',
          ...(bordered ? { borderWidth: 1, borderStyle: 'solid' } : { border: 'none' })
        }}
      >
        <Avatar
          src={owner.photoUrl}
          avatarLetters={initials}
          customSize='2.5rem'
          customFontSize='1rem'
          isPublicResource
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            minWidth: 0
          }}
        >
          <div
            style={{
              fontSize: '0.875rem',
              fontWeight: '600',
              color: 'var(--text-color-main)',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            {owner.firstName} {owner.lastName}
          </div>
          <div
            style={{
              fontSize: '0.75rem',
              color: 'var(--text-color-subtle)'
            }}
          >
            {owner.taskCount} {`${owner?.taskCount === 1 ? 'Task' : 'Tasks'}`}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div style={{ width: '150px', margin: '.5rem' }}>
      <div
        style={{
          display: 'flex',
          marginBottom: '.2rem',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Avatar
          src={owner.photoUrl}
          avatarLetters={owner.avatarLetters ?? ''}
          customSize='64px'
          isPublicResource
        />
        <div style={{ alignSelf: 'center', marginTop: '.5rem' }}>
          <div
            style={{ fontSize: '1rem', fontWeight: '400', textAlign: 'center' }}
          >
            {owner.firstName} {owner.lastName}
          </div>
          <div
            style={{
              fontSize: '0.75rem',
              color: 'var(--text-color-secondary)',
              textAlign: 'center'
            }}
          >
            {owner.taskCount} {`${owner?.taskCount === 1 ? 'Task' : 'Tasks'}`}
          </div>
        </div>
      </div>
    </div>
  )
}

OwnerTaskItem.propTypes = {
  owner: PropTypes.object,
  layout: PropTypes.oneOf(['card', 'row']),
  bordered: PropTypes.bool
}

OwnerTaskItem.defaultProps = {
  owner: {},
  layout: 'card',
  bordered: false
}

export default OwnerTaskItem
